import * as React from 'react';
import { Button, Drawer, Panel, PanelBody, PanelHeader } from '@teamsnap/teamsnap-ui';
import { FieldType } from './types';
import './ConfigureQuestionsDrawer.scss';
import AdditionalQuestionForm from './AdditionalQuestionForm';

type EditQuestionDrawerProps = {
  question: FieldType;
  orgId: number;
  formId: number;
  onClose: (updatedField?: FieldType, saveToLibrary?: boolean) => void;
};

const EditQuestionDrawer = ({ question, orgId, formId, onClose }: EditQuestionDrawerProps) => {
  const [isOpen, setIsOpen] = React.useState(false);

  React.useEffect(() => {
    setIsOpen(!!question);
  }, [question]);

  return (
    <div data-testid="edit-question-drawer" id="edit-question-drawer">
      {isOpen && (
        <Drawer
          open={isOpen}
          allowOverlayClose={false}
          style={{ maxWidth: '730px' }}
          closeFn={() => setIsOpen(false)}
          mods="u-sizeFull slide-in"
          overlayMods="fade-in"
          showOverlay={true}
          allowBodyScroll={false}
        >
          <Panel mods="Panel Questions">
            <PanelHeader>
              <div className="u-flex u-sizeFill u-flexAlignItemsCenter u-flexJustifyBetween">
                <h3>Question Settings</h3>
                <Button
                  testId="close-drawer"
                  type="link"
                  icon="dismiss"
                  mods="u-colorNeutral8"
                  onClick={() => {
                    onClose();
                    setIsOpen(false);
                  }}
                />
              </div>
            </PanelHeader>
            {question && (
              <AdditionalQuestionForm
                orgId={orgId}
                formId={formId}
                question={question}
                onCancel={() => {
                  onClose();
                  setIsOpen(false);
                }}
                onSave={(updatedField) => {
                  onClose(updatedField);
                }}
              />
            )}
          </Panel>
        </Drawer>
      )}
    </div>
  );
};

export default EditQuestionDrawer;
